import { ChatServicePromiseClient } from '@trustero/trustero-api-web/lib/chat/chat_grpc_web_pb'
import { ListChatsResponse } from '@trustero/trustero-api-web/lib/chat/chat_pb'
import { GrpcResponse } from 'src/components/async/hooks/types'
import { useSwrImmutableGrpc } from 'src/components/async/useSwrImmutableGrpc'
import { NewGrpcResponse } from 'src/components/async/hooks/types'
import { Empty } from 'google-protobuf/google/protobuf/empty_pb'

export const useGetChatHistory = (): GrpcResponse<ListChatsResponse> => {
  const { response } = useSwrImmutableGrpc(
    ChatServicePromiseClient.prototype.listChats,
    new Empty(),
    true,
  )

  return NewGrpcResponse(response)
}
